import { render } from "./VerticalFeedContent.vue?vue&type=template&id=9f3c8496"
import script from "./VerticalFeedContent.vue?vue&type=script&lang=js"
export * from "./VerticalFeedContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__